import React from 'react';

import { OverflowAvatarStack } from '../OverflowAvatarStack';
import { REPORTING_LINES_USER_CARD_SLOTS_LIMIT } from '../ReportingLinesChart';
import { MissingProfileCard, ReportingLinesUserCard } from '../ReportingLinesUserCard';
import * as Styled from '../styles';
import { type ReportingLinesUser } from '../types';

import { renderReportingLinesUserCard } from './shared';
import { getUsersForLayoutSections } from './util';

interface PeersSectionProps {
	selectedUser: ReportingLinesUser;
	peers: ReportingLinesUser[];
	showAvatarStack: boolean;
	toggleAvatarStack: () => void;
}

export const PeersSection = ({
	selectedUser,
	peers,
	showAvatarStack,
	toggleAvatarStack,
}: PeersSectionProps): React.JSX.Element => {
	const { usersForCards, usersForAvatarStack, numMissingProfiles } = getUsersForLayoutSections(
		peers,
		showAvatarStack ? REPORTING_LINES_USER_CARD_SLOTS_LIMIT - 1 : undefined,
	);

	return (
		<Styled.ReportsList testId="peers-section">
			<ReportingLinesUserCard user={selectedUser} selected testId="selected-user-card" />
			{usersForCards.map((user, index) => renderReportingLinesUserCard(user, `peer-${index}`))}
			{!usersForAvatarStack && numMissingProfiles > 0 && (
				<MissingProfileCard numMissingProfiles={numMissingProfiles} testId="missing-peers-card" />
			)}
			{usersForAvatarStack && (
				<Styled.ReportsStackContainer>
					<OverflowAvatarStack
						atlassianUsers={usersForAvatarStack}
						numFilteredMissingProfiles={numMissingProfiles}
						onClick={toggleAvatarStack}
					/>
				</Styled.ReportsStackContainer>
			)}
		</Styled.ReportsList>
	);
};
